import React from 'react';
import { Provider } from 'react-redux';
import * as settingsActions from '../../actions/settings';
import store from '../../configureStore';
import CalendarPage from '../../page/CalendarPage';
import SmallWidgetContainer from '../SmallWidgetContainer';

export default class CalendarWidgetContainer extends SmallWidgetContainer {
  render() {
    return (
      <div>
        <Provider store={store}>
          <CalendarPage {...this.props} />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingsActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingsActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingsActions.setSetting({ key, value }));
